export const generalMixin = {
  data () {
    return {
      apiPrefix: '/api',
      authApiUrl: '/auth',
      userApiUrl: '/users',
      jobApiUrl: '/jobs/',
      projectApiUrl: '/projects/',
      companyApiUrl: '/companies/',
      sheetApiUrl: '/sheets/',
      miscApiUrl: '/misc/',
      noteApiUrl:'/notes',
      projectUserSheetUrl: '/projects-users-sheets/',
      categoriesApiUrl: '/categories/',
      costsBudgetApiUrl: '/costs-budget/',
      notificationsApiUrl: '/notifications/',
      tasksApiUrl: '/tasks/',
      invoicedAmountsUrl: '/invoiced-amounts/',
      uploadImagesUrl: '/upload-images/',
      formatString: 'DD/MM/YYYY',
      formatBackendString: 'YYYY-MM-DD',
      modalClasses: {
        okSuccessClass: {
          'btn': true,
          'btn-primary': true,
          'modal-ok-button': true
        },
        okErrorClass: {
          'btn': true,
          'btn-danger': true,
          'modal-ok-button': true
        }
      },
      money: {
        decimal: '.',
        thousands: '\'',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    changeLocale (lang) {
      this.$store.commit('setLocale', lang)
      this.$root.$i18n.locale = this.$store.getters.getLocale
    },
    isFileImage (file) {
      const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png']
      return file && acceptedImageTypes.includes(file['type'])
    },
    toggleSideBar () {

      // SIDEBAR TOGGLE ACTION
      const sideBarToggle = document.getElementById('sidebar-toggle')

      if (sideBarToggle) {
        sideBarToggle.addEventListener('click', function () {
          const appBody = document.getElementById('app-body')
          appBody.classList.toggle('sidebar-mini')
        })
      }
    },
    modalWidth () {
      // calculate modal width based on screen width
      let width = window.innerWidth
      let modalWidth = '400px'

      if (width <= 568) {
        modalWidth = '90%'
      }
      return modalWidth
    },
    toTitleCase (phrase, split) {
      return phrase.toLowerCase().split(split)
        .map(word => word.charAt(0)
          .toUpperCase() + word.slice(1))
        .join('')
    },
    firstLetterLowerCase (phrase) {
      return phrase.charAt(0).toLowerCase() + phrase.slice(1)
    },
    parseErrors (errors) {
      let errMsgs = []

      // assign a value as an array in case it is not set this way 
      for(let p in errors) {
        if(!Array.isArray(errors[p])){
          let valueArray = []
          valueArray.push(errors[p])
          errors[p] = valueArray
        }
      }  

      for (let key in errors) {
        if (errors.hasOwnProperty(key)) {
          let keyTitleCase = this.firstLetterLowerCase(this.toTitleCase(key, '_'))
          let value = this.firstLetterLowerCase(this.toTitleCase(errors[key][0], ' '))
          value = value.substring(0, value.length - 1)
          value = value.replace(/[:\-.]+/ig, '')
          errMsgs.push({field: keyTitleCase, msg: value})
        }
      } 
      return errMsgs
    },
    createErrorMessage (errMsgs) {
      let msgs = []
      let errMsg = ''

      for (let obj of errMsgs) {
        msgs.push(this.$t(`message.${obj.field}`) + ':' + this.$t(`message.${obj.msg}`))
      }
      for (let msg of msgs) {
        errMsg += msg + '</br>'
      }

      return errMsg
    },
    // method for formatting numbers on tooltips for horizontal bars
    formatToolTipsHorizontalBars(tooltipItem, data) {
      let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
      if (value !== null)
         return 'CHF '+ value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "`");
      return 'CHF 0'
    },
    // method for returning the color of vertical bars for rolling forecast
    getBarColors (dates) {

      //get the first date of this month and format it properly using moment.js
      let firstDay = this.$moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD')

      // in case current month exists in the array of dates, there should be two
      if (dates.indexOf(firstDay) !== -1) {
        let arrayOfColors = []

        for (let i = 0; i < dates.length - 1; i++)
          arrayOfColors.push('rgba(236, 72, 78,.5)')
        arrayOfColors.push('rgba(66, 135, 245,.5)')

        return arrayOfColors

      } else {
        return 'rgba(236, 72, 78,.5)'
      }

    },
    // method for formatting numbers x’xxx.xx
    format (input = 0) {
      if (input == null)
        input = 0
      input = input.toFixed(0)
      return input.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1`')
    },
    
     // format data or label as per key passed
     formatDataOrLabel(data, key){
      let formattedArray = []
       
      for(let i=0; i<data.length; i++)
          formattedArray.push(data[i][key])

      return formattedArray; 
    },
    checkUrl(){
      if(window.location.href.substr(0,16) === 'https://vivareal'){
        return true
      }
      return false
    },
    // method for consolidating data for rolling forecast 
    consolidate (resp) {
      // extracting array of dates for rolling forecast and budgets
      let rollingForecastDates = resp.data.rolling_forecast.dates
      let budgetHistoryDates = resp.data.budget_history.dates

      // extracting an array of values for rolling forecast and budget history
      let rollingForecastCosts = resp.data.rolling_forecast.total_costs
      let budgetHistoryBudget = resp.data.budget_history.total_budget

      // creating a union of dates from two arrays and assigning a global variable
      let unionOfDates = [...new Set([...rollingForecastDates, ...budgetHistoryDates])]
      unionOfDates.sort()

      let mixedDates = []
      mixedDates = unionOfDates

      //creating an empty array for mixed data and filling it after
      let mixedChartData = new Array()

      // pushing all dates to the mixed chart array
      for (let i = 0; i < unionOfDates.length; i++)
        mixedChartData.push({date: unionOfDates[i]})

      for (let i = 0; i < mixedChartData.length; i++) {
        if (rollingForecastDates.indexOf(mixedChartData[i].date) !== -1)
          mixedChartData[i].forecastCosts = rollingForecastCosts[rollingForecastDates.indexOf(mixedChartData[i].date)]
        else
          mixedChartData[i].forecastCosts = 0
        if (budgetHistoryDates.indexOf(mixedChartData[i].date) !== -1)
          mixedChartData[i].historyBudget = budgetHistoryBudget[budgetHistoryDates.indexOf(mixedChartData[i].date)]
        else
          mixedChartData[i].historyBudget = 0
      }

      let mixedRollingForecastCosts = []
      let mixedTotalBudgetHistory = []

      for (let i = 0; i < mixedChartData.length; i++) {
        mixedRollingForecastCosts.push(mixedChartData[i].forecastCosts)
        mixedTotalBudgetHistory.push(mixedChartData[i].historyBudget)
      }

      let completeData = {}

      completeData.mixedDates = mixedDates
      completeData.mixedRollingForecastCosts = mixedRollingForecastCosts
      completeData.mixedTotalBudgetHistory = mixedTotalBudgetHistory

      return completeData
    },
    filterDuplicates (data, objKey) {
      const obj = {}
      const filteredArray = []

      for (let i = 0; i < data.length; i++) {
        obj[data[i][objKey]] = data[i]
      }

      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          filteredArray.push(obj[key])
        }
      }

      return filteredArray
    },
    removeDayFromDate (month) {
      return month.slice(0, 7)
    },
    getLastFriday () {
      let day = this.$moment().isoWeekday()

      if ([5, 6, 7].includes(day)) {
        return this.$moment().startOf('isoWeek').add(4, 'days').format(this.formatString)
      }

      return this.$moment().startOf('isoWeek').add(-3, 'days').format(this.formatString)
    },
    findByProperty (array, attr, value) {
      for (let i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    reverseFindByProperty (array, attr, value) {
      for (let i = array.length - 1; i >= 0; i--) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    uuidv4 () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    // Month picker methods
    containerClicked (event) {
      try {
        if (!event.target.className.startsWith('month-picker__container') && !event.target.offsetParent.className.startsWith('month-picker__container')) {
          if (event.target.id === 'start-date') {
            this.startDate = !this.startDate
            this.showMonthPicker = !this.showMonthPicker
          } else if (event.target.id === 'end-date') {
            this.endDate = !this.endDate
            this.showMonthPicker = !this.showMonthPicker
          } else {
            this.startDate = false
            this.endDate = false
            this.showMonthPicker = false
          }
        }
      } catch (e) {
        console.log()
      }

    },
    setDefaultDateForMonthPicker (startDate, endDate) {
      this.defaultStartDate.year = this.$moment(startDate).year()
      this.defaultStartDate.month = this.$moment(startDate).month() + 1

      this.defaultEndDate.year = this.$moment(endDate).year()
      this.defaultEndDate.month = this.$moment(endDate).month() + 1
    },
    setDate (date, ref, dateType) {
      if (dateType === 'start_date') {
        if (this.setStartDateOnMount) {
          ref[dateType] = this.$moment(date.from).format('YYYY-MM')
        } else {
          this.setStartDateOnMount = true
        }
      }

      if (dateType === 'end_date') {
        if (this.setEndDateOnMount) {
          ref[dateType] = this.$moment(date.from).format('YYYY-MM')
        } else {
          this.setEndDateOnMount = true
        }
      }

    },
    sortCategoriesData (cat) {
  
      switch (cat.type) {
        case 'personnel':
          if (this.findByProperty(this.categories['personnel'], 'id', cat.id) === -1) {
            this.categories['personnel'].push(cat)
          }
          break
        case 'material':
          if (this.findByProperty(this.categories['material'], 'id', cat.id) === -1) {
            this.categories['material'].push(cat)
          }
          break
        case 'foreign power':
          if (this.findByProperty(this.categories['foreign power'], 'id', cat.id) === -1) {
            this.categories['foreign power'].push(cat)
          }
          break
        case 'inventory':
          if (this.findByProperty(this.categories['inventory'], 'id', cat.id) === -1) {
            this.categories['inventory'].push(cat)
          }
          break
        case 'additional costs':
          if (this.findByProperty(this.categories['additional costs'], 'id', cat.id) === -1) {
            this.categories['additional costs'].push(cat)
          }
          break
        default:
          break
      }
    },
   
    // passing events
    passConfirmRemoveDocument (documentId) {
      this.$emit('confirmRemoveDocument', documentId)
    },
    passImportCategories (data) {
      this.$emit('importCategories', data)
    },
    passUpdateCategoryName (data) {
      this.$emit('updateCategoryName', data)
    },
    confirmCategory (data) {
      this.$emit('confirmCategory', data)
    },
    passBudgetDone () {
      this.$emit('budgetDone')
    },
    passAddCategory (data) {
      this.$emit('passAddCategory', data)
    },
    passConfirmDeleteAdditionalBudget(additionalBudgetId){
      //alert(additionalBudgetId)
      this.$emit('confirmDeleteAdditionalBudget', additionalBudgetId)
    },
    passConfirmDeleteCategory(id){
      //alert(additionalBudgetId)
      this.$emit('confirmDeleteCategory', id)
    }
  },
  computed: {
    computedCurrentLocale () {
      return this.$root.$i18n.locale
    }
  }
}